import { render } from "./RoundBtn.vue?vue&type=template&id=5f70a634"
import script from "./RoundBtn.vue?vue&type=script&lang=js"
export * from "./RoundBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__